<template>
  <div class="grab-order-config app-info-list app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-row type="flex" align="middle" v-for="value in info" :key="value.repair_config_id">
      <template>
        <a-col>{{value.title}}</a-col>
        <a-col>
          <a-row type="flex" align="middle">
            <a-col>{{value.text}}</a-col>
            <a-col>
              <a-button type="link" @click="showModal(value)">修改</a-button>
            </a-col>
          </a-row>
        </a-col>
      </template>
    </a-row>
    <a-modal :title="`修改${modal.title}`" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal" width="50%" destroy-on-close>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="社区" prop="community" v-if="modal.id === 1">
          <a-select v-model="form.community" placeholder="请选择社区" mode="multiple">
            <a-select-option :value="value.id" v-for="(value, index) in communityOptions" :key="index">{{value.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="modal.title" prop="time" v-else>
          <a-input-number v-model="form.time" :placeholder="`请输入${modal.title}`" :min="0" allow-clear></a-input-number>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import CommunityService from '@/io/community.js';
  import GrabOrderConfigService from '@/io/grab_order_config.js';

  export default {
    name: 'GrabOrderConfig',
    data() {
      return {
        info: [],
        communityOptions: [],
        // noteOne: null,
        // noteTwo: null,
        // noteThree: null,
        form: {
          community: [],
          time: null
        },
        rules: {
          community: [
            {
              required: true,
              message: '请选择社区'
            }
          ],
          time: [
            {
              required: true,
              message: '请填写'
            }
          ]
        },
        modal: {
          id: null,
          title: null,
          show: false,
          loading: false
        }
      }
    },
    mounted() {
      this.initCommunity().then(() => {
        this.initPage();
      });
    },
    methods: {
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptions = res;
        }).catch(err => {});
      },
      initPage() {
        GrabOrderConfigService.info().then(res => {
          this.info = res.map(val => {
            if (val.repair_config_field === 'grab_order_community_ids') {
              val.title = '开启抢单';
              val.text = val.repair_config_value.map(m => {
                return this.communityOptions.filter(x => x.id === m)[0].name;
              }).join('、');
            } else if (val.repair_config_field === 'grab_order_time_limit') {
              val.title = '抢单时限';
              val.text = `${val.repair_config_value}秒`;
            } else if (val.repair_config_field === 'grab_order_daily_upper_limit') {
              val.title = '抢单上限';
              val.text = `${val.repair_config_value}单`;
            } else if (val.repair_config_field === 'order_warning_overtime') {
              val.title = '超时预警';
              val.text = `${val.repair_config_value}分钟`;
            }
            return val;
          });
        }).catch(err => {});
      },
      showModal(data) {
        this.modal.title = data.title;
        this.modal.id = data.repair_config_id;
        this.form[data.repair_config_id === 1 ? 'community' : 'time'] = data.repair_config_value;
        this.modal.show = true;
      },
      confirmModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.modal.loading = true;
          GrabOrderConfigService.edit(this.modal.id, this.form.time || this.form.community).then(res => {
            this.$afterFormSubmit('修改成功', () => {
              this.initPage();
            });
          }).catch(err => {}).finally(() => {
            this.modal.loading = false;
            this.modal.show = false;
            this.form = {
              community: [],
              time: null
            };
          });
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>